import { render, staticRenderFns } from "./Userlogin.vue?vue&type=template&id=5b05dba4&"
import script from "./Userlogin.vue?vue&type=script&lang=js&"
export * from "./Userlogin.vue?vue&type=script&lang=js&"
import style0 from "./Userlogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports